import React, { useEffect } from 'react';

import {
  useAccountNumbersForm,
  useAccountNumbersState,
  useApplicationState,
  useDefaultAccountListener,
} from '@atlas/core';
import { Button } from '@atlas/ui';

import AccountNumberForm from './AccountNumberForm';

const AccountNumbersForm = () => {
  const {
    account: { accountNumbers },
    loading,
    resolved,
  } = useApplicationState();

  const { isAddButtonVisible, isLoading, isValid, onSubmit } = useAccountNumbersForm();
  const { appendField, initForm, state } = useAccountNumbersState();

  useEffect(() => {
    if (loading || !resolved) return;
    if (!accountNumbers?.length) return;

    initForm({ values: accountNumbers });
  }, [loading, resolved, accountNumbers, initForm]);

  useDefaultAccountListener();

  return (
    <form className="account-numbers-form">
      {state.map(({ useByDefault }, index) => (
        <AccountNumberForm fieldIndex={index} key={index} useByDefault={useByDefault}/>
      ))}
      <div className="account-numbers-form__footer">
        {isAddButtonVisible && (
          <Button
            className="add-account-button"
            icon="add"
            label="account_numbers_add_one_more_account"
            onClick={appendField}
            size="big"
            type="secondary"
          />
        )}
        <Button
          disabled={!isValid || isLoading}
          label="account_numbers_submit"
          loading={isLoading}
          onClick={onSubmit}
          size="big"
        />
      </div>
    </form>
);
};

export default AccountNumbersForm;
